import { v4 as uuid } from "uuid";

export default function getuuid() {
  return uuid();
}
